var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-upload-multiple" },
    [
      _c(
        "el-upload",
        {
          ref: "uploader",
          attrs: {
            "list-type": "picture-card",
            "auto-upload": _vm.autoUpload,
            disabled: _vm.disabled,
            action: _vm.action,
            name: _vm.name,
            data: _vm.data,
            "http-request": _vm.request,
            "file-list": _vm.defaultFileList,
            "show-file-list": _vm.showFileList,
            accept: _vm.accept,
            multiple: _vm.multiple,
            limit: _vm.limit,
            "before-upload": _vm.before,
            "on-remove": _vm.remove,
            "on-success": _vm.success,
            "on-error": _vm.error,
            "on-preview": _vm.handlePreview,
            "on-exceed": _vm.handleExceed,
          },
          scopedSlots: _vm._u([
            {
              key: "tip",
              fn: function () {
                return [
                  _vm.tip
                    ? _c("div", { staticClass: "el-upload__tip" }, [
                        _vm._v(_vm._s(_vm.tip)),
                      ])
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "file",
              fn: function (ref) {
                var file = ref.file
                return [
                  _c(
                    "div",
                    { staticClass: "image-upload-list-item" },
                    [
                      _c("el-image", {
                        staticClass: "el-upload-list__item-thumbnail",
                        attrs: {
                          src: file.url,
                          fit: "cover",
                          "preview-src-list": _vm.preview,
                          "initial-index": _vm.preview.findIndex(function (n) {
                            return n == file.url
                          }),
                          "hide-on-click-modal": "",
                          "append-to-body": "",
                          "z-index": 9999,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "placeholder",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "image-upload-multiple-image-slot",
                                    },
                                    [_vm._v(" Loading... ")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      !_vm.disabled && file.status == "success"
                        ? _c(
                            "div",
                            { staticClass: "image-upload__item-actions" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "del",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemove(file)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-delete" })]
                              ),
                            ]
                          )
                        : _vm._e(),
                      file.status == "ready" || file.status == "uploading"
                        ? _c(
                            "div",
                            { staticClass: "image-upload__item-progress" },
                            [
                              _c("el-progress", {
                                attrs: {
                                  percentage: file.percentage,
                                  "text-inside": true,
                                  "stroke-width": 16,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._t("default", function () {
            return [_c("i", { staticClass: "el-icon-plus" })]
          }),
        ],
        2
      ),
      _c(
        "span",
        { staticStyle: { display: "none !important" } },
        [
          _c("el-input", {
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }